module.exports = __webpack_public_path__ + "img/t0.7a24a409.png";